// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./core-dms/static/css/reset.css
// module id = 226
// module chunks = 130 131 132 133 134 135